import {
  getVirtualTourCubePreviewUrl,
  locationsContentBaseUrl,
} from '~/utils/location.urls';

export default function getPointPreviewURL(point, location) {
  return getVirtualTourCubePreviewUrl(Number(location), point);
}

export function getPointCubePreviewUrl(point, location) {
  return `${locationsContentBaseUrl()}/locations/${location}/model/cube/${point}_cubefront.jpg`;
}
